// src/components/TemplateWorkspace/workspaceUploads/WorkspaceHeader.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './WorkspaceHeader.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faSpinner, faCheck } from '@fortawesome/free-solid-svg-icons';

import workspace_draft_icon from '../../../assets/images/icons/workspace-draft-icon.png';
import upward_trend_arrow_icon from '../../../assets/images/icons/upward-trend-arrow-icon.png';
import upload_small_icon from '../../../assets/images/icons/upload-small-icon.png';
import warning_icon from '../../../assets/images/icons/warning-icon.png';

const WorkspaceHeader = ({ 
  workspaceTitle, 
  setWorkspaceTitle, 
  isTranscriptAvailable, 
  isLocalTranscriptAvailable,
  workspaceCreatedFunction,
  isSaveButtonEnabled, 
  isYTProcessing,
  isLOCALProcessing,
  isTranscriptError,
  isTranscriptEmpty,
}) => {
  const [buttonText, setButtonText] = useState('Save Workspace');
  const [isFocused, setIsFocused] = useState(false);

  const handleSave = async () => {
    if (workspaceTitle.trim() === '') return;
    setButtonText('Saving...');
    try {
      if (workspaceCreatedFunction) await workspaceCreatedFunction();
      setButtonText('Saved 🎉');
      setTimeout(() => setButtonText('Save Workspace'), 2000);
    } catch {
      setButtonText('Save Workspace');
    }
  };

  const isMaxLength = workspaceTitle.length === 32;
  const isTitleEmpty = workspaceTitle.trim() === '';
  const disabled = !isSaveButtonEnabled || isTitleEmpty;

  // choose icon
  let icon = faSave;
  if (buttonText === 'Saving...') icon = faSpinner;
  else if (buttonText.startsWith('Saved')) icon = faCheck;



return (
  <div className="workspace-header-container">
    <div className="title-save-container">
      <div className="title-input-wrapper">
        <input
          type="text"
          className={`
            workspace-title-input
            ${isMaxLength ? 'input-max' : ''}
            ${workspaceTitle !== '' ? 'has-title' : ''}
            ${isFocused ? 'input-focused' : ''}
            ${isTitleEmpty ? 'input-error' : ''}
          `}
          placeholder="Enter workspace title"
          value={workspaceTitle}
          onChange={e => setWorkspaceTitle(e.target.value)}
          maxLength={32}
          aria-label="Workspace Title"
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
        />

        {isTranscriptError ? (
          <Link to="/workspace/new" className="badge badge-error">
            <img src={warning_icon} alt="Error" className="need-title-icon" />
            <span className="need-title-text">Upload Error</span>
          </Link>
        ) : (
          <>
            {(isTranscriptAvailable || isLocalTranscriptAvailable) && (
              <div className="badge badge-active">
                <img src={upward_trend_arrow_icon} alt="Active" className="active-icon-workspace" />
                <span className="active-text">Active</span>
              </div>
            )}

            {(!isTranscriptAvailable && !isLocalTranscriptAvailable && isTitleEmpty) && (
              <div className="badge badge-need-title">
                <img src={workspace_draft_icon} alt="Need Title" className="need-title-icon" />
                <span className="need-title-text">Title</span>
              </div>
            )}

            {(
              !isTranscriptEmpty &&
              !isTranscriptAvailable &&
              !isLocalTranscriptAvailable &&
              !isTitleEmpty &&
              !isYTProcessing &&
              !isLOCALProcessing
            ) && (
              <div className="badge badge-draft">
                <img src={workspace_draft_icon} alt="Draft" className="draft-icon" />
                <span className="draft-text">Draft</span>
              </div>
            )}

            {(!isTranscriptAvailable && isYTProcessing) && (
              <div className="badge badge-uploading">
                <img src={upload_small_icon} alt="Uploading" className="draft-icon" />
                <span className="draft-text">Uploading</span>
              </div>
            )}

            {(!isLocalTranscriptAvailable && isLOCALProcessing) && (
              <div className="badge badge-uploading">
                <img src={upload_small_icon} alt="Processing" className="draft-icon" />
                <span className="draft-text">Processing</span>
              </div>
            )}
          </>
        )}
      </div>

      <button
        className={`workbutton ${disabled ? 'workbutton-disabled' : ''} ${buttonText.startsWith('Saved') ? 'workbutton-saved' : ''}`}
        onClick={handleSave}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={icon} spin={buttonText === 'Saving...'} className="workbutton-icon" />
        <span className="workbutton-label">
          {buttonText === 'Save Workspace' ? 'Save' : buttonText.replace(' 🎉','')}
        </span>
      </button>
    </div>
  </div>
);





};

export default WorkspaceHeader;
